import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()

import StimulusReflex from 'stimulus_reflex'

const controllers = import.meta.glob("./controllers/**/*_controller.js", {
  eager: true,
})

registerControllers(application, controllers)
